import { render, staticRenderFns } from "./WorksUser.vue?vue&type=template&id=46591c43&scoped=true"
import script from "./WorksUser.vue?vue&type=script&lang=js"
export * from "./WorksUser.vue?vue&type=script&lang=js"
import style0 from "./WorksUser.vue?vue&type=style&index=0&id=46591c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46591c43",
  null
  
)

export default component.exports